<template>
    <!-- Nothing -->
</template>

<script>
    export default {
        props: {
            field: {
                type: Object,
                required: true,
            }
        }
    }
</script>